import api from "../../../config/axios/configAxios";

export const getNotConfirmedUsers = async () =>
  api.get(`/api/Admin/Users/not-confirmed?Page=1&Limit=100`);

export const confirmNotConfrmedUser = async (userId: string, data: any) =>
  api.post(`/api/Admin/Users/${userId}/confirm`, data);